export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13764.8b00848d.jpg";